import { cva } from 'class-variance-authority';
import styles from '../presentation/styles.module.scss';

export const toastVariants = cva(styles.wrapper, {
  variants: {
    status: {
      success: styles.success,
      danger: styles.danger,
    },
  },
  defaultVariants: {
    status: 'success',
  },
});

export const closeButtonVariants = cva(styles.closeButton, {
  variants: {
    status: {
      success: styles.closeButtonSuccess,
      danger: styles.closeButtonDanger,
    },
  },
  defaultVariants: {
    status: 'success',
  },
});
